import { createTheme } from "@mantine/core";
import { navigate } from "gatsby";
import { barber_men, boys, cats, dogs, facial_men, facial_sweet, girls, hair_styling, massage_men, massage_spa, nails_ladies, nails_men, other } from "../images";

// export const baseApi = 'https://api.salonteq.com'
export const baseApi =
  process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://api.salonteq.com';
export const handleClose = () => {
    const redirectPath = localStorage.getItem("redirectAfterLogin");
    if (redirectPath) {
      localStorage.removeItem("redirectAfterLogin");
      navigate(redirectPath);
    } else {
      navigate("/");
    }
  };
export const googleClientId ="68233477640-8jqrd8eopmkonamc25asu3s027mp166i.apps.googleusercontent.com"
// export const website = {
//   home: {
//     hero: [
//       { name: 'title', type: 'shortText' },
//       { name: 'description', type: 'longText' },
//       { name: 'image', type: 'image' },
//       { name: "link", type: "link"},
//     ],
//     services: [
//         { name: "title", type: "shortText" },
//         {
//           name: "cards",
//           type: "array",
//           items: [
//             {name: "title", type: "shortText"},
//             {name: "description", type: "longText"},
//             {name: "icon", type: "image"}
//           ]
//         }
//     ],
//   },
//   about: {
//     main: [{ name: 'content', type: 'longText' }],
//     team: [{ name: 'teamPhoto', type: 'image' }],
//   },
//     // ... other pages
// };
export const theme = createTheme({
    fontFamily: 'Arabic',
    // colorScheme: 'light', 
    headings: {fontFamily: 'Roboto, sans-serif', sizes: {h1: { fontSize: '2rem' },},},
    components:{
      Tabs:{
        styles: {
          list:{
            borderLeftWidth: '2rem',
          },
        },
      },
    },
    colors: {
      // andrew: ["#ffede4","#ffdbcd","#ffb69b","#ff8e64","#fe6d37","#fe571a","#ff4c09","#e43c00","#cb3400","#b12900"],
      // appBlue: ["#edf1fc","#d8dff3","#adbde9","#8098e0","#5b79d9","#4466d6","#385dd5","#2c4dbc","#2444a9","#183a95"],
      // andrew2: ['#FFF4E6', '#FFF4E6', '#FFF4E6', '#FFF4E6', '#FFF4E6', '#FFF4E6', '#FF4500', '#FFF4E6', '#FFF4E6', '#FFF4E6'],
      // stg: 	 ["#ffecee","#f8d6da","#efabb2","#e67d87","#de5663","#db3e4c","#da3140","#c12432","#ad1d2c","#981224"],
      // ksa: 	 ["#ffe9eb","#ffd2d3","#f9a2a5","#f47074","#ef454a","#ed2b30","#ed1b21","#d30e15","#bd0412","#a6000c"],
      // ss: 	["#ffe9eb","#ffd2d3","#f9a2a5","#f47074","#ef454a","#ed2b30","#093eff","#0031e4","#002AD2","#020A6D"],
      salon:["#fff6e4","#f7ebd4","#ebd5ae","#dfbe84","#d4aa60","#ce9d49","#cb973c","#b4832d","#a07424","#8b6318"],
      // ksaB: 	 ["#eff0ff","#dcdcf3","#b5b6e4","#8c8ed4","#6a6cc7","#5457c1","#494bbe","#3a3da8","#333697","#292d86"]
    },
  })
export const serviceMap: Record<string, {image: string; title: string; titleAr: string; places: number; code: number;}[]> = {
  Gents: [
    { image: massage_men, title: "Massage", titleAr: "تدليك", places: 0, code: 0 },
    { image: barber_men, title: "Barber", titleAr: "حلاقه وتصفيف", places: 1, code: 1 },
    { image: facial_men, title: "Facial & Skin Care", titleAr: "العناية بالوجه والبشرة", places: 2, code: 2 },
    { image: nails_men, title: "Manicure & Pedicure", titleAr: "مانيكير وباديكير", places: 3, code: 3 },
  ],
  Ladies: [
    { image: massage_spa, title: "Massage & Spa", titleAr: "التدليك والسبا", places: 0, code: 4 },
    { image: hair_styling, title: "Hair Styling", titleAr: "تصفيف الشعر", places: 1, code: 5 },
    { image: nails_ladies, title: "Nails", titleAr: "أظافر", places: 2, code: 6 },
    { image: facial_sweet, title: "Facial", titleAr: "العناية بالوجه", places: 3, code: 7 },
  ],
  Kids: [
    { image: boys, title: "Boys", titleAr: "الأولاد", places: 0, code: 8 },
    { image: girls, title: "Girls", titleAr: "البنات", places: 1, code: 9 },
  ],
  Pets: [
    { image: cats, title: "Cats", titleAr: "قطط", places: 0, code: 10 },
    { image: dogs, title: "Dogs", titleAr: "كلاب", places: 1, code: 11 },
    { image: other, title: "Other", titleAr: "أخرى", places: 2, code: 12 },
  ],
  Default: [
    { image: "/loader.gif", title: "Massage & Spa", titleAr: "التدليك والسبا", places: 0, code: 0 },
    { image: "/loader.gif", title: "Hair Styling", titleAr: "تصفيف الشعر", places: 1, code: 1 },
    { image: "/loader.gif", title: "Nails", titleAr: "أظافر", places: 2, code: 2 },
    { image: "/loader.gif", title: "Facial", titleAr: "العناية بالوجه", places: 3, code: 3 },
  ],
};
export const getServiceByCode = (code: number) => Object.values(serviceMap).flat().find(s => s.code === code) ?? null;

let id = 0
export const getId = () => { return id }
export const setId = (d:number) => { id = d }
export const languages = [
  { code: 'ar', name: 'ع', flag: '/flags/ar.webp' },
  { code: 'en', name: 'En', flag: '/flags/en.webp' },
];
export type LanguageSelector = {
    code: string;
    name: string;
    flag: string;
};
export const availableLanguages = languages.map((lang) => lang.code);

export const navTranslations: { [key: string]: { [key: string]: string } } = {
  ar: {
    home: "صالون تك",
    services: "الخدمات",
    webApps: "تطبيقات الويب",
    websites: "المواقع الإلكترونية",
    mobileApps: "تطبيقات الهاتف المحمول",
    iot: "إنترنت الأشياء",
    electronics: "الإلكترونيات",
    mixedSolutions: "حلول مختلطة",
    aboutUs: "من نحن",
    ourStory: "قصتنا",
    sustainability: "الاستدامة",
    careers: "انضم إلينا",
    contactUs: "اتصل بنا",
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
    gents: "رجالي",
    ladies: "نسائي",
    kids: "أطفال",
    pets: "حيوانات",
  },
  en: {
    home: "Salon Tek",
    services: "Services",
    webApps: "Web Apps",
    websites: "Websites",
    mobileApps: "Mobile Apps",
    iot: "IoT",
    electronics: "Electronics",
    mixedSolutions: "Mixed Solutions",
    aboutUs: "About Us",
    ourStory: "Our Story",
    sustainability: "Sustainability",
    careers: "Careers",
    contactUs: "Contact Us",
    login: "Login",
    logout: "Logout",
    gents: "Gents",
    ladies: "Ladies",
    kids: "Kids",
    pets: "Pets",
  },
};
export const textVariant = (delay: number) => {
  return {
    hidden: { y: -50, opacity: 0, },
    show: {
      y: 0, opacity: 1,
      transition: { type: "spring", duration: 1.25, delay: delay, },
    },
  };
};

// export const fadeIn = (direction: string, type: any, delay: any, duration: any) => {
//   return {
//     hidden: {
//       x: direction === "left" ? 100 : direction === "right" ? -100 : 0,
//       y: direction === "up" ? 100 : direction === "down" ? -100 : 0,
//       opacity: 0,
//     },
//     show: {
//       x: 0,
//       y: 0,
//       opacity: 1,
//       transition: {
//         type: type,
//         delay: delay,
//         duration: duration,
//         ease: "easeOut",
//       },
//     },
//   };
// };

// export const zoomIn = (delay, duration) => {
//   return {
//     hidden: {
//       scale: 0,
//       opacity: 0,
//     },
//     show: {
//       scale: 1,
//       opacity: 1,
//       transition: {
//         type: "tween",
//         delay: delay,
//         duration: duration,
//         ease: "easeOut",
//       },
//     },
//   };
// };

// export const slideIn = (direction: string, type: any, delay: any, duration: any) => {
//   return {
//     hidden: {
//       x: direction === "left" ? "-100%" : direction === "right" ? "100%" : 0,
//       y: direction === "up" ? "100%" : direction === "down" ? "100%" : 0,
//     },
//     show: {
//       x: 0,
//       y: 0,
//       transition: {
//         type: type,
//         delay: delay,
//         duration: duration,
//         ease: "easeOut",
//       },
//     },
//   };
// };

// export const staggerContainer = (staggerChildren: any, delayChildren: any) => {
//   return {
//     hidden: {},
//     show: {
//       transition: {
//         staggerChildren: staggerChildren,
//         delayChildren: delayChildren || 0,
//       },
//     },
//   };
// };

/*
    I need to reevaluate the structure of the website menus to make sure that the website is structured in a way that is easy to navigate.

    I have 3 categories of menu groups

    A) Groups Without Login

    Group 1: Home (no children)
    Group 2: Services (6 children)
    1) webApps
    2) websites
    3) mobileApps
    4) iot
    5) electronics
    6) mixedSolutions

    Group 3: About Us (4 children)
    1) Our Mission
    2) Our Vision
    3) Join Us
    4) Environment

    Group 4: Contact Us (no children)
    
    B) Groups With User Login (for my customers to monitor the work progress and payments and due dates and all what makes my business better and maybe not in my mind now)
    Group 5: Customer (n children)
    1) Dashboard
    2) Projects
    3) Payments
    4) Due Dates
    5) Messages
    ... and more

    (or a dedicated dashboard for the customers to manage the projects and the payments and the due dates and the messages)

    C) Groups With Admin Login (My Dashboard to manage the website and the customers and the projects and the payments and the due dates and the messages)
    I whish that I can see a didcated dashboard for the admin to manage the website and the customers and the projects and the payments and the due dates and the messages

    before coding can you brain storm through this idea and if my arrangement of the menus (specially in the first menu group) is good or not and if you have any suggestions to make the website more user friendly and more easy to navigate please let me know
   

Main Navigation (Shared Across Roles)
- Home  
- Services  
    - Digital Solutions  
        - Web Apps  
        - Websites  
        - Mobile Apps  
    - Engineering Solutions  
        - IoT  
        - Electronics  
        - Mixed Solutions  
- About Us  
    - Our Story  
    - Careers  
    - Sustainability  
- Contact Us  

Logged-In Users
- Dashboard  
    - Overview  
    - Projects  
    - Payments  
    - Due Dates  
    - Messages  
    - Reports  

Admins
- Dashboard  
    - Manage Users  
    - Manage Projects  
    - Payments Overview  
    - Notifications  
    - Settings 
    */